<template>
  <div>
    <v-card elevation="5">
      <v-toolbar color="primaryLight" dark dense style="z-index: 2;">
        <!-- Toolbar para poder enganchar el FAB -->
        <v-tabs v-model="categoriaSelected" dark slider-color="secondary">
          <v-tab v-for="(medio, n) in categoriasMedios" :key="medio.CATEGORIA" ripple>
            <v-icon>{{ medio.ICONO }}</v-icon>
            <label class="caption pb-3 pr-1">{{ numMedios[n] }}</label>
            {{ medio.CATEGORIA }}
          </v-tab>
        </v-tabs>

        <v-tooltip bottom>
          <template #activator="{ on, attrs }">
            <v-btn fab small v-bind="attrs" v-on="on" color="secondary" bottom right absolute :disabled="isIncendioFinalizado" @click="showDialogAddMedios = true">
              <v-icon color="primary">mdi-plus</v-icon>
            </v-btn>
          </template>
          <span>Añadir medio</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template #activator="{ on, attrs }">
            <v-btn fab small v-bind="attrs" v-on="on" color="secondary" bottom right absolute :disabled="isIncendioFinalizado" @click="showDialogEditSectores = true" :style="{marginRight: '50px'}">
              <v-icon color="primary">mdi-pencil</v-icon>
            </v-btn>
          </template>
          <span>Editar sectores</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template #activator="{ on, attrs }">
            <v-btn
              fab
              small
              v-bind="attrs"
              v-on="on"
              color="secondary"
              bottom
              right
              absolute
              :disabled="isIncendioFinalizado"
              @click="mostrarSoloActivos = !mostrarSoloActivos"
              :style="{ marginRight: '100px' }"
            >
              <v-icon color="primary">
                {{ mostrarSoloActivos ? 'mdi-eye' : 'mdi-eye-off' }}
              </v-icon>
            </v-btn>
          </template>
          <span>Medios activos</span>
        </v-tooltip>
      </v-toolbar>

      <v-card-text class="pa-0">
        <vx-medios-table :medios="mediosTable" @editMedioEmergencia="editMedioEmergencia" @setFecha="setFecha" />
      </v-card-text>
    </v-card>

    <vx-dialog-add-medios :show="showDialogAddMedios" :idEmergencia="idEmergencia" @aceptar="acceptAddMediosEmergencia" @cancelar="cancelAddMediosEmergencia" />

    <vx-dialog-edit-medio :show="showDialogEditMedio" :emergencia="emergencia" :medioSector="medioEdit" @aceptar="acceptEditMedioEmergencia" @cancelar="cancelEditMedioEmergencia" @deleteMedioEmergencia="deleteMedioEmergencia" />
    <vx-change-medio-sector-table :show="showDialogEditSectores" :medios="mediosTable" :idEmergencia="idEmergencia" @acceptEditSectorEmergencia="acceptEditSectorEmergencia" @close="closeChangeMedioSector" />
  </div>
</template>

<script>
import constant from '@/helpers/constants'

import MediosTable from './MediosTable.vue'
import DialogAddMedios from './DialogAddMedios.vue'
import DialogEditMedio from './DialogEditMedio.vue'
import ChangeMedioSectorTable from './ChangeMedioSectorTable.vue'

export default {
  components: {
    'vx-medios-table': MediosTable,
    'vx-dialog-add-medios': DialogAddMedios,
    'vx-dialog-edit-medio': DialogEditMedio,
    'vx-change-medio-sector-table': ChangeMedioSectorTable
  },

  props: {
    sectoresSelected: Array,
    idEmergencia: String
  },

  data: () => ({
    numMedios: [],
    categoriasMedios: [],

    categoriaSelected: 0,

    showDialogAddMedios: false,
    showDialogEditMedio: false,
    showDialogEditSectores: false,

    mostrarSoloActivos: false,

    medioEdit: {}
  }),

  computed: {
    incendio () {
      return this.$store.getters['incendio/getIncendioByID'](this.idIncendio)
    },

    emergencia () {
      return this.$store.getters['emergencia/getEmergenciaByID'](this.idEmergencia)
    },

    isIncendioFinalizado () {
      return this.$store.getters['incendio/isIncendioFinalizado'](this.idIncendio)
    },

    medios () {
      return this.$store.getters['medio/medios']
    },

    sectores () {
      let sectores = []

      if (this.emergencia) {
        sectores = this.emergencia.SECTORES
      }

      return sectores
    },

    mediosTable () {
      let medioSector = {}
      let mediosTable = []

      this.countNumMedios()

      // Recorro los sectores seleccionados
      for (let i = 0; i < this.sectoresSelected.length; i++) {
        let sectorSelected = this.sectoresSelected[i]

        // Recorro los medios del sector
        for (let j = 0; j < this.sectores[sectorSelected].MEDIOS.length; j++) {
          let medioSectorSelected = this.sectores[sectorSelected].MEDIOS[j]

          for (let k = 0; k < this.medios.length; k++) {
            let medio = this.medios[k]

            const esMedioValido = medioSectorSelected.ID_MEDIO === medio.ID_MEDIO && medioSectorSelected.FECHA_AVISO
            const cumpleCategoria = this.isIncludedInCategoria(medio) || this.categoriaSelected === 0
            const cumpleFiltroActivo = medio.ACTIVO === this.mostrarSoloActivos

            if (esMedioValido && cumpleCategoria && cumpleFiltroActivo) {
              medioSector = {
                ID_EMERGENCIA: this.idEmergencia,
                ID_SECTOR: medioSectorSelected.ID_SECTOR,
                SECTOR: sectorSelected.SECTOR,
                ID_MEDIO_SECTOR: medioSectorSelected.ID_MEDIO_SECTOR,
                ID_MEDIO: medio.ID_MEDIO,
                MEDIO: medio.MEDIO,
                ESTADO: medio.ESTADO,
                FECHA_AVISO: medioSectorSelected.FECHA_AVISO,
                FECHA_LLEGADA: medioSectorSelected.FECHA_LLEGADA,
                FECHA_SALIDA: medioSectorSelected.FECHA_SALIDA,
                FECHA_LLEGADA_BASE: medioSectorSelected.FECHA_LLEGADA_BASE,
                FECHA_LLEGADA_GEOFENCING: medioSectorSelected.FECHA_LLEGADA_GEOFENCING,
                FECHA_FIN_DESCANSO: medioSectorSelected.FECHA_FIN_DESCANSO,
                NUM_COMPONENTES: medioSectorSelected.NUM_COMPONENTES,
                PLANIFICACION: medioSectorSelected.PLANIFICACION
              }

              mediosTable.push(medioSector)
            }
          }
        }
      }

      return mediosTable
    },

    disabledByRol () {
      // Deshabilita funciones dependiendo del rol
      return !this.$store.getters['usuario/isCurrentUsuarioAdmin']
    }
  },

  watch: {
    idIncendio () {
      this.categoriaSelected = 0
    }
  },

  methods: {
    isIncludedInCategoria (medio) {
      let categoriaMedio = this.categoriasMedios[this.categoriaSelected].CATEGORIA

      let isAereoAndSelected = categoriaMedio === 'Aéreo' && this.isMedioAereo(medio)
      let isTerrestreAndSelected = categoriaMedio === 'Terrestre' && this.isMedioTerrestre(medio)
      let isRecursoAndSelected = categoriaMedio === 'Recurso' && this.isMedioRecurso(medio)

      return isAereoAndSelected || isTerrestreAndSelected || isRecursoAndSelected
    },

    isMedioTerrestre (medio) {
      return medio.CLASE === constant.maestras.CLASE.MEDIO_TERRESTRE.NOMBRE
    },
    isMedioAereo (medio) {
      return medio.CLASE === constant.maestras.CLASE.MEDIO_AEREO.NOMBRE
    },
    isMedioRecurso (medio) {
      let clasesRecurso = ['GRUPO', constant.maestras.CLASE.PERSONAL.NOMBRE, constant.maestras.CLASE.BRIGADA.NOMBRE]

      return clasesRecurso.includes(medio.CLASE)
    },

    countNumMedios () {
      let todos = 0
      let numRecurso = 0
      let numTerrestre = 0
      let numAereo = 0

      // Recorro los sectores seleccionados
      for (let i = 0; i < this.sectoresSelected.length; i++) {
        let index = this.sectoresSelected[i]
        let sector = this.sectores[index]

        // Recorro los medios del sector
        for (let j = 0; j < sector.MEDIOS.length; j++) {
          let medioSectorSelected = JSON.parse(JSON.stringify(sector.MEDIOS[j]))

          // if (medioSectorSelected.FECHA_AVISO && !medioSectorSelected.FECHA_SALIDA) {
          // Busco el medio correspondiente para saber el tipo
          let medio = this.medios.find(x => x.ID_MEDIO === medioSectorSelected.ID_MEDIO)
          if (medio) {
            if (this.isMedioRecurso(medio)) {
              numRecurso++
            }
            if (this.isMedioTerrestre(medio)) {
              numTerrestre++
            }
            if (this.isMedioAereo(medio)) {
              numAereo++
            }
            todos++
          }
          // }
        }
      }
      // pongo el numero de medios segun esta en la tabla
      this.numMedios = [todos, numRecurso, numTerrestre, numAereo]
    },

    // Añadir medio
    acceptAddMediosEmergencia (medios) {
      this.showDialogAddMedios = false
      this.$store.dispatch('emergencia/asignarMedios', medios)
    },

    cancelAddMediosEmergencia () {
      this.showDialogAddMedios = false
    },

    // Click en boton reloj

    async setFecha (medio) {
      this.$store.dispatch('emergencia/editMedioEmergencia', medio)
      try {
        if (medio.FECHA_LLEGADA && this.incendio &&
        this.incendio.ESTADOS[0].TIPO_INCENDIO_ESTADO.VALUE ===
      this.$store.state.incendio.tiposIncendioEstado[0].VALUE) {
          const estadoIncendio = {
            ID_INCENDIO_ESTADO: this.$uuid.createUUID(),
            ID_INCENDIO: this.incendio.ID_INCENDIO,
            ID_TIPO_INCENDIO_ESTADO:
            this.$store.state.incendio.tiposIncendioEstado[1].ID_TIPO_INCENDIO_ESTADO,
            FECHA: this.$date.now(),
            TIPO_INCENDIO_ESTADO: this.$store.state.incendio.tiposIncendioEstado[1]
          }
          await this.$store.dispatch('emergencia/addEstadoEmergencia', estadoIncendio)
        }
      } catch (error) {
        console.error('Error al actualizar el medio:', error)
      }
    },

    // Editar medio
    editMedioEmergencia (medio) {
      this.showDialogEditMedio = true
      this.medioEdit = medio
    },

    acceptEditMedioEmergencia (medioEdit) {
      this.showDialogEditMedio = false
      this.$store.dispatch('emergencia/editMedioEmergencia', medioEdit)
      this.medioEdit = {}
    },

    cancelEditMedioEmergencia () {
      this.showDialogEditMedio = false
      this.medioEdit = {}
    },

    // Borrar medio
    deleteMedioEmergencia (medioDelete) {
      this.showDialogEditMedio = false
      this.medioEdit = {}
      this.$store.dispatch('emergencia/deleteMedioEmergencia', medioDelete)
    },

    // Editar sectores
    editSectorEmergencia (medio) {
      this.showDialogEditMedioSector = true
      this.medioEdit = medio
    },
    acceptEditSectorEmergencia (medioEdit) {
      this.showDialogEditMedioSector = false
      this.$store.dispatch('emergencia/editMedioEmergencia', medioEdit)
      this.medioEdit = {}
    },
    closeChangeMedioSector () {
      this.showDialogEditSectores = false
      this.medioEdit = {}
    }

  },

  created () {
    this.categoriasMedios = null
    this.categoriasMedios = JSON.parse(JSON.stringify(constant.categoriasMedios))
    this.categoriasMedios.unshift(constant.allMedios)
  }
}
</script>

<style scoped>
</style>
